/**
 * Created by Sumit on 7/13/2017.
 */
import {
  GetCollectionFiltersMsg,
  GetCollectionFiltersQuery,
  GetCollectionFiltersResp,
  ValueList
} from "../../autogenerated/ZoomBridge";
import HashMap from "./../../protocol/HashMap";
import CollectionUtil from "./../../queries/lightbox/CollectionUtil";

export default class GetCollectionFilters {
  static COLLECTION_NAME_KEY = "COLLECTION_NAME";
  static TAGS_KEY = "TAGS";
  static CREATED_IN_KEY = "CREATED_IN";
  static MODIFIED_IN_KEY = "MODIFIED_IN";
  /**
   *
   * @param filters,       Map<String,String> for Collection Metadata(Filters)
   */
  constructor(filterMap) {
    this.filterMap = filterMap;
  }

  /**
   * This method will return GetCollectionFiltersResp which contains the following fields:-
   *  collectionNames,       List of Collection Names
   *  collectionTags,        List of Collection Tags
   *  filters,               Map of metadata Name to List of ValueList type object
   *
   *  Here ValueList Object contains following fields
   *  values,           List of values in String
   *
   * @returns {Promise.<GetCollectionFiltersResp,ErrorId>}
   */
  run() {
    const query = new GetCollectionFiltersQuery();
    const msg = new GetCollectionFiltersMsg();
    msg.setFilters(this.filterMap);
    query.message = msg;
    return query.run();
  }


  /**
   *
   * @param {GetCollectionFiltersResp} getCollectionFiltersResp
   * @returns {HashMap}
   */
  static createMetadaKeyToValuesMapFromResponse(getCollectionFiltersResp) {
    const hashMap = new HashMap();
    let collectionStatusValuesSet = false;

    /**
     * @type {HashMap}
     */
    const filtersMap = getCollectionFiltersResp.getFilters();
    if (filtersMap) {
      filtersMap.forEach(function (key, value) {
        /**
         * @type {ValueList}
         */
        let valueList = value.getValues() ? value.getValues() : null;
        if (key === CollectionUtil.COLLECTION_STATUS_KEY) {
          //valueList = CollectionUtil.getCollectionStatusValues();
          collectionStatusValuesSet = true;
        }
        hashMap.put(key, valueList);
      });
    }
    if (!collectionStatusValuesSet) {
      hashMap.put(CollectionUtil.COLLECTION_STATUS_KEY, CollectionUtil.getCollectionStatusValues());
    }
    return hashMap;
  }
}